import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST } from "../../../utils/Methods";
import { APIS } from "../../../utils/APIS";
import { IDS } from "../../../utils/IDS";

// 🔹 LOGIN
// export const CreateLogin = createAsyncThunk(
//   "/login",
//   async (data, { rejectWithValue }) => {
//     try {
//       console.log(" Login request payload:", data);
//       const res = await POST(APIS.Auth.login, data);
//       console.log(" Login Response:", res);

//       if (res?.success && res?.data?.token) {
//         Cookies.set("ots_website_security", res.data.token, {
//           expires: 7,
//           secure: true,
//           sameSite: "strict",
//         });
//         console.log(" Token saved in cookies:", res.data.token);
//       } else {
//         console.warn(" No token found in login response");
//       }

//       console.log(
//         " Current cookie value:",
//         Cookies.get("ots_website_security"),
//       );
//       return res;
//     } catch (error) {
//       console.error(" Login API error:", error);
//       return rejectWithValue(error?.response?.data || error.message);
//     }
//   },
// );

// 🔹 SIGNUP
export const CreateCustomerSignup = createAsyncThunk(
  "/customer-signup",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.CreateCustomerSignup, data);

      if (res?.success && res?.data?.token) {
        Cookies.set("ots_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
      }

      return res;
    } catch (error) {
      console.error("Signup API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

//  Thunk for sendOtp
export const sendMobileOtp = createAsyncThunk(
  "/sendOtp",
  async (data, { rejectWithValue }) => {
    try {
      const otp = await POST(APIS.Auth.SEND_OTP, data);

      if (otp?.success === false) {
        return rejectWithValue(otp);
      }

      return otp;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Something went wrong" },
      );
    }
  },
);

// // Thunk for verifying login
export const verifyOtp = createAsyncThunk(
  "/otp-verification",
  async (data, { rejectWithValue }) => {
    try {
      console.log("verifyOtp", data);

      const response = await POST(APIS.Auth.VERIFY_OTP, data);

      if (response?.success && response?.data?.token) {
        Cookies.set("pst_website_security", response.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });

        console.log("Token saved successfully:", response.data.token);
      }
      if (response?.success) {
        return response;
      }

      return rejectWithValue(response);
    } catch (error) {
      console.error("Verify OTP error:", error);

      return rejectWithValue(
        error?.response?.data || {
          message: error?.message || "Something went wrong",
        },
      );
    }
  },
);

export const CreateVendor1Signup = createAsyncThunk(
  "/vendor-signup",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.CreateVendor1Signup, data);

      if (res?.success && res?.data?.token) {
        Cookies.set("ots_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
        console.log("Token saved from signup:", res.data.token);
      }

      return res;
    } catch (error) {
      console.error("Signup API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const CreateVendor2Signup = createAsyncThunk(
  "/vendor-shop",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.CreateVendor2Signup, data);

      if (res?.success && res?.data?.token) {
        Cookies.set("ots_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
        console.log("Token saved from signup:", res.data.token);
      }

      return res;
    } catch (error) {
      console.error("Signup API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const CreateVendor3Signup = createAsyncThunk(
  "/vendor-receive-docs",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.CreateVendor3Signup, data);

      if (res?.success && res?.data?.token) {
        Cookies.set("ots_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
        console.log("Token saved from signup:", res.data.token);
      }

      return res;
    } catch (error) {
      console.error("Signup API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const CreateExpert1Signup = createAsyncThunk(
  "/expert-signup",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.CreateExpert1Signup, data);

      if (res?.success && res?.data?.token) {
        Cookies.set("ots_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
        console.log("Token saved from signup:", res.data.token);
      }

      return res;
    } catch (error) {
      console.error("Signup API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const CreateExpert2Signup = createAsyncThunk(
  "/expert-details",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.CreateExpert2Signup, data);

      if (res?.success && res?.data?.token) {
        Cookies.set("ots_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
        console.log("Token saved from signup:", res.data.token);
      }

      return res;
    } catch (error) {
      console.error("Signup API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

// export const sendLoginOtp = createAsyncThunk(
//   "/sendLoginOtp",
//   async (data, { rejectWithValue }) => {
//     try {
//       const otp = await POST(APIS.Auth.sendLoginOtp, data);
//       if (otp?.success === false) {
//         return rejectWithValue(otp);
//       }
//       return otp;
//     } catch (error) {
//       console.log(error, "error error");

//       return rejectWithValue(error);
//     }
//   },
// );

export const sendLoginOtp = createAsyncThunk(
  "/sendLoginOtp",
  async (data, { rejectWithValue }) => {
    try {
      const otp = await POST(APIS.Auth.sendLoginOtp, data);

      if (otp?.success === false) {
        return rejectWithValue(otp);
      }

      return otp;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

// export const LoginverifyOtp = createAsyncThunk(
//   "/login",
//   async (data, { rejectWithValue }) => {
//     try {
//       console.log(" Login request payload:", data);
//       const res = await POST(APIS.Auth.LoginverifyOtp, data);
//       console.log(" Login Response:", res);

//       if (res?.success && res?.data?.token) {
//         Cookies.set("ots_website_security", res.data.token, {
//           expires: 7,
//           secure: true,
//           sameSite: "strict",
//         });

//         Cookies.set("ots_user_type", res.data.type);
//         console.log(" Token saved in cookies:", res.data.token);
//       } else {
//         console.warn(" No token found in login response");
//       }

//       console.log(
//         " Current cookie value:",
//         Cookies.get("ots_website_security"),
//       );
//       return res;
//     } catch (error) {
//       console.error(" Login API error:", error);
//       return rejectWithValue(error?.response?.data || error.message);
//     }
//   },
// );
export const LoginverifyOtp = createAsyncThunk(
  "/login",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.LoginverifyOtp, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      if (res?.success && res?.data?.token) {
        Cookies.set("ots_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });

        Cookies.set("ots_user_type", res.data.type);
      }

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);
export const GETCustomer = createAsyncThunk(
  "/get-customer",
  async (_, { rejectWithValue }) => {
    try {
      const token = Cookies.get("ots_website_security");

      const res = await GET(APIS.Auth.GETCustomer, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const GETVendor = createAsyncThunk(
  "/get-vendor",
  async ({ type }, { rejectWithValue }) => {
    try {
      const token = Cookies.get("ots_website_security");

      const res = await GET(APIS.Auth.GETVendor, {
        params: { type },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const GETExpert = createAsyncThunk(
  "/get-expert",
  async (_, { rejectWithValue }) => {
    try {
      const token = Cookies.get("ots_website_security");

      const res = await GET(APIS.Auth.GETExpert, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const Update_Customer = createAsyncThunk(
  "/update-customer-profile",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Auth.Update_Customer, data);

      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Update_Vendor = createAsyncThunk(
  "/update-vendor-profile",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Auth.Update_Vendor, data);

      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Update_Vendor_Shop = createAsyncThunk(
  "/update-vendor-shop",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Auth.Update_Vendor_Shop, data);

      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Update_Expert = createAsyncThunk(
  "/update-expert-profile",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Auth.Update_Expert, data);

      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const LoginSlice = createSlice({
  name: "login",
  initialState: {
    loginData: null,
    loginStatus: IDS.SLICESTATUS.Idle,
    loginError: null,

    signupData: null,
    signupStatus: IDS.SLICESTATUS.Idle,
    signupError: null,

    sendOtpData: null,
    sendOtpStatus: IDS.SLICESTATUS.Idle,
    sendOtpError: null,

    verifyOtpData: null,
    verifyOtpStatus: IDS.SLICESTATUS.Idle,
    verifyOtpError: null,

    sendLoginOtpData: null,
    sendLoginOtpStatus: IDS.SLICESTATUS.Idle,
    sendLoginOtpError: null,

    verifyLoginOtpData: null,
    verifyLoginOtpStatus: IDS.SLICESTATUS.Idle,
    verifyLoginOtpError: null,

    getCustomerData: null,
    getCustomerStatus: IDS.SLICESTATUS.Idle,
    getCustomerError: null,

    getVendorData: null,
    getVendorStatus: IDS.SLICESTATUS.Idle,
    getVendorError: null,

    getExpertData: null,
    getExpertStatus: IDS.SLICESTATUS.Idle,
    getExpertError: null,

    updateCustomerStatus: IDS.SLICESTATUS.Idle,
    updateCustomerError: null,

    updateExpertStatus: IDS.SLICESTATUS.Idle,
    updateExpertError: null,

    updateVendorStatus: IDS.SLICESTATUS.Idle,
    updateVendorError: null,

    getVendorShopData: null,
    updateVendorShopStatus: IDS.SLICESTATUS.Idle,
    updateVendorShopError: null,
  },
  reducers: {
    logoutUser: (state) => {
      Cookies.remove("ots_website_security");
      Cookies.remove("ots_user_type");

      state.loginData = null;
      state.signupData = null;
      state.loginStatus = IDS.SLICESTATUS.Idle;
      state.signupStatus = IDS.SLICESTATUS.Idle;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔹 LOGIN
      // .addCase(CreateLogin.pending, (state) => {
      //   state.loginStatus = IDS.SLICESTATUS.Loading;
      // })
      // .addCase(CreateLogin.fulfilled, (state, action) => {
      //   state.loginStatus = IDS.SLICESTATUS.Succeeded;
      //   state.loginData = action.payload?.data || null;
      // })
      // .addCase(CreateLogin.rejected, (state, action) => {
      //   state.loginStatus = IDS.SLICESTATUS.Failed;
      //   state.loginError = action.payload;
      // })

      // 🔹 SIGNUP
      .addCase(CreateCustomerSignup.pending, (state) => {
        state.signupStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateCustomerSignup.fulfilled, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Succeeded;
        state.signupResponse = action.payload;
      })
      .addCase(CreateCustomerSignup.rejected, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Failed;
        state.signupError = action.payload;
      })

      // 🔹 SEND OTP
      .addCase(sendMobileOtp.pending, (state) => {
        state.sendOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(sendMobileOtp.fulfilled, (state, action) => {
        state.sendOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.sendOtpData = action.payload?.data || null;
      })
      .addCase(sendMobileOtp.rejected, (state, action) => {
        state.sendOtpStatus = IDS.SLICESTATUS.Failed;
        state.sendOtpError = action.payload;
      })

      // 🔹 VERIFY OTP
      .addCase(verifyOtp.pending, (state) => {
        state.verifyOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.verifyOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.verifyOtpData = action.payload?.data || null;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.verifyOtpStatus = IDS.SLICESTATUS.Failed;
        state.verifyOtpError = action.payload;
      })

      .addCase(CreateVendor1Signup.pending, (state) => {
        state.signupStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateVendor1Signup.fulfilled, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Succeeded;
        state.signupResponse = action.payload;
      })
      .addCase(CreateVendor1Signup.rejected, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Failed;
        state.signupError = action.payload;
      })

      .addCase(CreateVendor2Signup.pending, (state) => {
        state.signupStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateVendor2Signup.fulfilled, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Succeeded;
        state.signupResponse = action.payload;
      })
      .addCase(CreateVendor2Signup.rejected, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Failed;
        state.signupError = action.payload;
      })

      .addCase(CreateVendor3Signup.pending, (state) => {
        state.signupStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateVendor3Signup.fulfilled, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Succeeded;
        state.signupResponse = action.payload;
      })
      .addCase(CreateVendor3Signup.rejected, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Failed;
        state.signupError = action.payload;
      })

      .addCase(CreateExpert1Signup.pending, (state) => {
        state.signupStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateExpert1Signup.fulfilled, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Succeeded;
        state.signupResponse = action.payload;
      })
      .addCase(CreateExpert1Signup.rejected, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Failed;
        state.signupError = action.payload;
      })

      .addCase(CreateExpert2Signup.pending, (state) => {
        state.signupStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateExpert2Signup.fulfilled, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Succeeded;
        state.signupResponse = action.payload;
      })
      .addCase(CreateExpert2Signup.rejected, (state, action) => {
        state.signupStatus = IDS.SLICESTATUS.Failed;
        state.signupError = action.payload;
      })

      .addCase(sendLoginOtp.pending, (state) => {
        state.sendLoginOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(sendLoginOtp.fulfilled, (state, action) => {
        state.sendLoginOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.sendLoginOtpData = action.payload?.data || null;
      })
      .addCase(sendLoginOtp.rejected, (state, action) => {
        state.sendLoginOtpStatus = IDS.SLICESTATUS.Failed;
        state.sendLoginOtpError = action.payload;
      })

      .addCase(LoginverifyOtp.pending, (state) => {
        state.verifyLoginOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(LoginverifyOtp.fulfilled, (state, action) => {
        state.verifyLoginOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.verifyLoginOtpData = action.payload?.data || null;
      })
      .addCase(LoginverifyOtp.rejected, (state, action) => {
        state.verifyLoginOtpStatus = IDS.SLICESTATUS.Failed;
        state.verifyLoginOtpError = action.payload;
      })

      .addCase(GETCustomer.pending, (state) => {
        state.getCustomerStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETCustomer.fulfilled, (state, action) => {
        state.getCustomerStatus = IDS.SLICESTATUS.Succeeded;
        state.getCustomerData = action.payload?.data || null;
      })
      .addCase(GETCustomer.rejected, (state, action) => {
        state.getCustomerStatus = IDS.SLICESTATUS.Failed;
        state.getCustomerError = action.payload;
      })

      .addCase(GETVendor.pending, (state) => {
        state.getVendorStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETVendor.fulfilled, (state, action) => {
        state.getVendorStatus = IDS.SLICESTATUS.Succeeded;
        state.getVendorData = action.payload?.data || null;
      })
      .addCase(GETVendor.rejected, (state, action) => {
        state.getVendorStatus = IDS.SLICESTATUS.Failed;
        state.getVendorError = action.payload;
      })

      .addCase(GETExpert.pending, (state) => {
        state.getExpertStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETExpert.fulfilled, (state, action) => {
        state.getExpertStatus = IDS.SLICESTATUS.Succeeded;
        state.getExpertData = action.payload?.data || null;
      })
      .addCase(GETExpert.rejected, (state, action) => {
        state.getExpertStatus = IDS.SLICESTATUS.Failed;
        state.getExpertError = action.payload;
      })

      .addCase(Update_Customer.pending, (state) => {
        state.updateCustomerStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update_Customer.fulfilled, (state, action) => {
        state.updateCustomerStatus = IDS.SLICESTATUS.Succeeded;
        state.getCustomerData = {
          ...state.getCustomerData,
          ...action.payload?.data,
        };
      })
      .addCase(Update_Customer.rejected, (state, action) => {
        state.updateCustomerStatus = IDS.SLICESTATUS.Failed;
        state.updateCustomerError = action.payload;
      })

      .addCase(Update_Expert.pending, (state) => {
        state.updateExpertStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update_Expert.fulfilled, (state, action) => {
        state.updateExpertStatus = IDS.SLICESTATUS.Succeeded;
        state.getExpertData = {
          ...state.getExpertData,
          ...action.payload?.data,
        };
      })
      .addCase(Update_Expert.rejected, (state, action) => {
        state.updateExpertStatus = IDS.SLICESTATUS.Failed;
        state.updateExpertError = action.payload;
      })

      .addCase(Update_Vendor.pending, (state) => {
        state.updateVendorStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update_Vendor.fulfilled, (state, action) => {
        state.updateVendorStatus = IDS.SLICESTATUS.Succeeded;
        state.getVendorData = {
          ...state.getVendorData,
          ...action.payload?.data,
        };
      })
      .addCase(Update_Vendor.rejected, (state, action) => {
        state.updateVendorStatus = IDS.SLICESTATUS.Failed;
        state.updateVendorError = action.payload;
      })

      .addCase(Update_Vendor_Shop.pending, (state) => {
        state.updateVendorShopStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update_Vendor_Shop.fulfilled, (state, action) => {
        state.updateVendorShopStatus = IDS.SLICESTATUS.Succeeded;
        state.getVendorShopData = {
          ...state.getVendorShopData,
          ...action.payload?.data,
        };
      })
      .addCase(Update_Vendor_Shop.rejected, (state, action) => {
        state.updateVendorShopStatus = IDS.SLICESTATUS.Failed;
        state.updateVendorShopError = action.payload;
      });
  },
});

export const { logoutUser } = LoginSlice.actions;
export default LoginSlice.reducer;
